module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.municipe) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('v-form-cadastro-agendamento')], 1)])] : _vm._e(), _vm._v(" "), (_vm.showLoginForm) ? [_c('div', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-info",
    class: {
      active: _vm.activeComponent === 'login'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeComponent = 'login'
      }
    }
  }, [_vm._v("LOGIN")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-info",
    class: {
      active: _vm.activeComponent === 'cadastro'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeComponent = 'cadastro'
      }
    }
  }, [_vm._v("CADASTRO")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(_vm.activeComponent === 'login') ? _c('v-form-login', {
    attrs: {
      "redirect-to": _vm.$route.fullPath
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeComponent === 'cadastro') ? _c('v-form-cadastro-municipe') : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "visible-xs"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-info",
    class: {
      active: _vm.activeComponent === 'login'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeComponent = 'login'
      }
    }
  }, [_vm._v("LOGIN")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-info",
    class: {
      active: _vm.activeComponent === 'cadastro'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeComponent = 'cadastro'
      }
    }
  }, [_vm._v("CADASTRO")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(_vm.activeComponent === 'login') ? _c('v-form-login', {
    attrs: {
      "redirect-to": _vm.$route.fullPath
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeComponent === 'cadastro') ? _c('v-form-cadastro-municipe') : _vm._e()], 1)])] : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11940f32", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11940f32"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/agendas/cadastro.vue
// module id = 361
// module chunks = 1